export const getClientName = (client) => {
	const { surname, businessName } = client;
	const firstName = client.firstName || client.firstname;
	return businessName || `${surname || ''} ${firstName || ''}`.trim();
};
